import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../../redux/pageSlice";
import "./OurFactory.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import ImgBox from "../../../Component/ReuseComponent/ImgBox/ImgBox";
import IRTCBox from "../../../Component/ReuseComponent/ITCBox/IRTCBOX";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";

export default function OurFactoryArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    dispatch(fetchPageData({ page_id: 9, lang: "ar" }));
  }, [dispatch]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");
  const section3 = data.find((s) => s.section_id === "3");

  return (
    <>
      <LoaderWrap>
        <div className="OurFactoryContainer">
          <section>
            <OurFactoryS1 section1={section1} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurFactoryS2">
            <OurFactoryS2 section2={section2} contents={section2?.contents} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="OurFactoryS3">
            <OurFactoryS3 section3={section3} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function OurFactoryS1({ section1 }) {
  const sentences = section1?.description?.split(".").filter(Boolean) || [];

  const Para = sentences.map((s) => s.trim()).join(".<br /><br />") + ".";
  return (
    <>
      <div className="OurFactoryS1">
        <TC3L
          Head="مصنعنا"
          Title={section1?.title}
          TitleWidthMob="80vw"
          Para={
            <>
              <div dangerouslySetInnerHTML={{ __html: Para }} />
            </>
          }
          ParaWidth="56vw"
          ParaWidthMob="89vw"
        />
        <div className="OFS1P2">
          <ImgBox ImgSrc={section1?.image} ImgAlt="" imgHeight="50vw" />
        </div>
      </div>
    </>
  );
}

function OurFactoryS2({ section2, contents }) {
  return (
    <>
      <div className="OurFactoryS2">
        <TC3L Title={section2?.title} TitleWidthMob="89vw" Para={section2?.description} ParaWidth="56vw" ParaWidthMob="89vw" />
        <div className="OFS2P2 ar">
          {contents?.map((item) => (
            <OFS2P2Box key={item.id} Title={item.title} Description={item.description} imgSrc={item.image} imgAlt={item.title} />
          ))}
        </div>
      </div>
    </>
  );
}

function OFS2P2Box({ imgSrc, imgAlt, Title, Description }) {
  return (
    <>
      <div className="OFS2P2Box">
        <div className="OFS2P2BoxP1">
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className="OFS2P2BoxP2 ar TGLo32PxPC">{Title}</div>
        <div className="OFS2P2BoxP3 ar TFut20PxPC">{Description}</div>
      </div>
    </>
  );
}

function OurFactoryS3({ section3 }) {
  const sentences = section3?.description?.split(".").filter(Boolean) || [];

  const Para = sentences
    .map((s, i) => {
      const sentence = s.trim();
      if (i < 3) return sentence + ". ";
      if (i === 3) return sentence + ".<br /><br />";
      return sentence + ".";
    })
    .join("")
    .trim();
  return (
    <>
      <div className="OurFactoryS3">
        <IRTCBox
          Title={section3?.title}
          TitleWidth=""
          Para={
            <>
              <div dangerouslySetInnerHTML={{ __html: Para }} />
            </>
          }
          ParaWidth=""
          ImgSrc={section3?.image}
          ImgAlt={section3?.title}
          ImgOrder="1"
        />
      </div>
    </>
  );
}
